import styled from 'styled-components';
import ShowHideToggle from '../../../../../shared/showHideToggle';

export const StyledShowHideToggle = styled(ShowHideToggle)`
    bottom: -1.6rem;
    cursor: pointer;
    width: auto;
`;
